<div role="dialog" (scroll)="$event.stopImmediatePropagation()" (mousedown)="clickOut($event)" [class.init]="toggle.init"
  [class.fs]="toggle.fs">

  <div [class]="maxWidth" (mouseover)="$event.stopImmediatePropagation()"
    (mousedown)="$event.stopImmediatePropagation()" (mouseup)="$event.stopImmediatePropagation()"
    (dblclick)="$event.stopImmediatePropagation()" (click)="$event.stopImmediatePropagation()">

    <div [class.lib-elevation-1]="!toggle.fs">

      <div [class.disable-scroll]="toggle.disableScroll">

        <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{data: data}">          
        </ng-container> 

        <p *ngIf="message && !html">{{message}}</p>

        <div *ngIf="message && !!html" class="html" [innerHtml]="message"></div>

      </div>

      <nav class="lib-nav" [hidden]="!toggle.nav">

        <button type="button" [class]="'lib-button' + cancelTheme" (click)="close($event, 'cancel')" [hidden]="!cancel">
          <span role="button">{{ cancel }}</span>
        </button>

        <span class="lib-spacer" role="none"></span>

        <button type="button" [class]="'lib-button-' + okTheme" (click)="close($event, 'ok')" [hidden]="!ok" data-test="modal-ok-button">
          <span role="button">{{ ok }}</span>
        </button>

      </nav>
    </div>
  </div>
</div>
